module.exports = __webpack_public_path__ + "img/jk_icon_danweijigongchengjikeclick.557ce55c.png";